import { ConfigureAuthenticatorApp, RemoveAuthenticatorApp } from '@/features/profile';
import { reactive } from '@/core/reactive/reactive';

export const TwoFactorSetup = reactive.component(
  ({ data }) => {
    if (data.twoFactorSetup.id && data.twoFactorSetup.isValidated) {
      return <RemoveAuthenticatorApp />;
    }

    return <ConfigureAuthenticatorApp />;
  },
  {
    name: 'TwoFactor',
    queries: () => [
      {
        name: 'twoFactorSetup',
        execute: db => db.twofactor.toCollection().first(),
        defaultValue: {},
      },
    ],
  },
);
